import * as React from "react"

import { cn } from "@/lib/utils"
import { gentleFormatLine } from "@/lib/textformat"

const NO_SPELLCHECK_TYPES = ["number", "email", "password", "tel", "url", "date", "time", "datetime-local"];
const isTextLike = (t) => t === undefined || t === "text" || t === "search";

const Input = React.forwardRef(({ className, type, spellCheck, autoFormat, onBlur, ...props }, ref) => {
  const sc = spellCheck !== undefined ? spellCheck : !NO_SPELLCHECK_TYPES.includes(type);
  const af = autoFormat !== undefined ? autoFormat : isTextLike(type);
  const handleBlur = (e) => {
    if (af && e.target) {
      const formatted = gentleFormatLine(e.target.value);
      if (formatted !== e.target.value) {
        const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
        if (setter) setter.call(e.target, formatted); else e.target.value = formatted;
        e.target.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
    onBlur?.(e);
  };
  return (
    <input
      type={type}
      spellCheck={sc}
      onBlur={handleBlur}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
